import React, { useState, useEffect } from 'react';

const StickyQRDownload = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showButton, setShowButton] = useState(false);
  
  const qrCodeImage = "https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/qrcode.png";

  // Check if device is mobile/tablet
  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  // Handle scroll to show/hide button on mobile/tablet
  useEffect(() => {
    if (!isMobile) {
      setShowButton(true); // Always show on desktop
      return;
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;
      const halfViewport = viewportHeight / 2;
      
      // Show button when user scrolls past half of first viewport
      if (scrollPosition > halfViewport) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    // Start with button hidden on mobile
    setShowButton(false);
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  const handleClick = () => {
    if (isMobile) {
      setShowMobilePopup(true);
    } else {
      setIsFlipped(!isFlipped);
    }
  };

  const handleDownloadClick = () => {
    window.open('http://onelink.to/u77u8t', '_blank');
    setShowMobilePopup(false);
  };

  const closeMobilePopup = () => {
    setShowMobilePopup(false);
  };

  return (
    <>
      {/* Desktop Version - Original Component */}
      {!isMobile && showButton && (
        <div 
          className="fixed bottom-4 right-4 z-50"
          style={{ willChange: 'transform', opacity: 1, transform: 'none' }}
        >
          <div 
            className="relative rounded-xl transition-all duration-500 ease-in-out transform hover:scale-110 cursor-pointer"
            style={{
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(0, 0, 0, 0.55)',
              borderRadius: '12px',
              opacity: 1,
              padding: isFlipped ? '16px' : '8px',
              width: isFlipped ? '120px' : '80px',
              height: isFlipped ? '120px' : '80px',
              perspective: '1000px'
            }}
            onClick={handleClick}
          >
            {/* Flip Container */}
            <div 
              className="relative w-full h-full transition-transform duration-500 ease-in-out"
              style={{
                transformStyle: 'preserve-3d',
                transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
              }}
            >
              {/* Front Side - QR Code */}
              <div 
                className="absolute inset-0 w-full h-full"
                style={{
                  backfaceVisibility: 'hidden',
                  transform: 'rotateY(0deg)'
                }}
              >
                <img
                  src={qrCodeImage}
                  alt="Download App QR Code"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    borderRadius: 'inherit',
                    objectPosition: 'center center',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Back Side - Text */}
              <div 
                className="absolute inset-0 w-full h-full flex flex-col justify-center items-center text-center"
                style={{
                  backfaceVisibility: 'hidden',
                  transform: 'rotateY(180deg)'
                }}
              >
                <div className="text-white text-sm font-medium leading-tight">
                  Track all your
                </div>
                <div className="text-white text-sm font-medium leading-tight">
                  investments
                </div>
                <div className="text-gray-300 text-xs mt-2">
                  Scan the QR to Download App
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile/Tablet Modern Floating Button */}
      {isMobile && showButton && (
        <div className="fixed bottom-6 right-4 z-50 animate-fadeIn">
          <button
            onClick={handleClick}
            className="group relative overflow-hidden rounded-2xl shadow-2xl transition-all duration-500 transform hover:scale-110 active:scale-95"
            style={{
              background: 'linear-gradient(135deg, #F49611 0%, #F6A839 50%, #F49611 100%)',
              backgroundSize: '200% 200%',
              animation: 'gradientShift 3s ease infinite',
              boxShadow: '0 8px 32px rgba(244, 150, 17, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1)'
            }}
          >
            {/* Animated background pulse */}
            <div 
              className="absolute inset-0 rounded-2xl opacity-30"
              style={{
                background: 'radial-gradient(circle at center, rgba(255,255,255,0.3) 0%, transparent 70%)',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />
            
            {/* Button content */}
            <div className="relative flex items-center gap-3 px-5 py-3.5">
              {/* Phone icon with subtle animation */}
              <div className="relative">
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  className="text-white transition-transform duration-300 group-hover:scale-110"
                >
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <line x1="12" y1="18" x2="12.01" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                {/* Notification dot */}
                <div 
                  className="absolute -top-1 -right-1 w-2 h-2 rounded-full"
                  style={{ 
                    background: '#113262',
                    animation: 'ping 2s cubic-bezier(0, 0, 0.2, 1) infinite'
                  }}
                />
              </div>
              
              <span className="text-white font-semibold text-sm tracking-wide">
                Get App
              </span>
              
              {/* Arrow with hover animation */}
              <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                className="text-white transition-transform duration-300 group-hover:translate-x-1"
              >
                <path d="M5 12h14m-7-7l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </button>
        </div>
      )}

      {/* Enhanced Mobile Popup */}
      {showMobilePopup && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-6">
          {/* Enhanced backdrop with blur */}
          <div 
            className="absolute inset-0 transition-all duration-300"
            style={{
              background: 'linear-gradient(135deg, rgba(17, 50, 98, 0.8) 0%, rgba(28, 82, 160, 0.6) 100%)',
              backdropFilter: 'blur(8px)'
            }}
            onClick={closeMobilePopup}
          />
          
          {/* Modern popup card */}
          <div 
            className="relative w-full max-w-sm transform transition-all duration-500 ease-out scale-100"
            style={{
              background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)',
              borderRadius: '24px',
              boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1)',
              animation: 'slideUp 0.5s ease-out'
            }}
          >
            {/* Decorative top accent */}
            <div 
              className="absolute top-0 left-1/2 transform -translate-x-1/2 w-12 h-1 rounded-full"
              style={{ 
                background: 'linear-gradient(90deg, #113262, #1C52A0)',
                marginTop: '8px'
              }}
            />
            
            {/* Close button */}
            <button
              onClick={closeMobilePopup}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-200 hover:bg-gray-100"
              style={{ color: '#8A8A8A' }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            {/* Content */}
            <div className="p-8 pt-12 text-center">
              {/* Investment portfolio icon with glow effect */}
              <div 
                className="relative w-16 h-16 mx-auto mb-6 rounded-2xl flex items-center justify-center"
                style={{ 
                  background: 'linear-gradient(135deg, #113262 0%, #1C52A0 100%)',
                  boxShadow: '0 8px 32px rgba(17, 50, 98, 0.3)'
                }}
              >
                {/* Investment/Portfolio tracking icon */}
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
                  {/* Chart/Graph lines */}
                  <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" strokeLinecap="round" strokeLinejoin="round"/>
                  {/* Mobile device outline */}
                  <rect x="3" y="1" width="18" height="22" rx="2" ry="2" stroke="white" strokeWidth="1" fill="none" opacity="0.3"/>
                  {/* Trending up arrow */}
                  <path d="M16 6l4 4-4 4" stroke="#A2B8D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                
                {/* Glow effect */}
                <div 
                  className="absolute inset-0 rounded-2xl opacity-20"
                  style={{
                    background: 'linear-gradient(135deg, #113262, #1C52A0)',
                    filter: 'blur(8px)',
                    transform: 'scale(1.1)'
                  }}
                />
              </div>
              
              <h3 
                className="text-xl font-bold mb-3"
                style={{ color: '#113262' }}
              >
                Maxiom Wealth App
              </h3>
              
              <p 
                className="text-sm mb-8 leading-relaxed"
                style={{ color: '#545454' }}
              >
                Track investments, get insights, and manage your portfolio seamlessly on mobile
              </p>

              {/* Action buttons */}
              <div className="space-y-3">
                <button
                  onClick={handleDownloadClick}
                  className="w-full py-4 rounded-2xl font-semibold text-white transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden group"
                  style={{
                    background: 'linear-gradient(135deg, #113262 0%, #1C52A0 100%)',
                    boxShadow: '0 4px 24px rgba(17, 50, 98, 0.4)'
                  }}
                >
                  {/* Button shine effect */}
                  <div 
                    className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{
                      background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.2) 50%, transparent 70%)',
                      transform: 'translateX(-100%)',
                      animation: 'shine 1.5s ease-in-out infinite'
                    }}
                  />
                  <span className="relative flex items-center justify-center gap-2">
                    Download Now
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7,10 12,15 17,10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                  </span>
                </button>
                
                <button
                  onClick={closeMobilePopup}
                  className="w-full py-3 rounded-2xl font-medium transition-all duration-200 border"
                  style={{ 
                    color: '#7B9BC8',
                    borderColor: '#A2B8D8',
                    backgroundColor: 'rgba(232, 238, 246, 0.3)'
                  }}
                >
                  Not Now
                </button>
              </div>
              
              <p 
                className="text-xs mt-4 opacity-60"
                style={{ color: '#8A8A8A' }}
              >
                Available on iOS & Android
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Add required CSS animations */}
      <style jsx>{`
        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.05); }
        }
        
        @keyframes ping {
          75%, 100% { transform: scale(2); opacity: 0; }
        }
        
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes shine {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </>
  );
};

export default StickyQRDownload;